import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AllTicketsOldComponent} from './all-tickets-old/all-tickets-old.component';
import {StateComponent} from './state/state.component';
import {DataTableModule} from 'angular5-data-table';
import {SharedModule} from '../../shared.module';

@NgModule({
  imports: [
    CommonModule,
    DataTableModule
  ],
    declarations: [
        AllTicketsOldComponent,
        StateComponent]
})
export class Angular5DataTableModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/angular5-data-table/angular5-data-table.module.ts